import FinalFooter2 from "./finalFooter2";
import MiddleFooter2 from './middleFooter2'

export default function Footer2() {
  return (
    <div className="hidden  7:block || px-10 11:px-20 11:pb-0
    || 7:border-lgrayd border-solid border-c1 
     || bg-lgray2   ">
      <MiddleFooter2 />
      <FinalFooter2 />
    </div>
  );
}
